<template>
  <div class="performance-value-management">
    <!-- 顶部区域 -->
    <div class="header-section">
      <div class="tabs-wrapper" _p="l-19px t-18px">
        <span class="tab-item" :class="{ active: activeTab === 'music' }" @click="activeTab = 'music'">音乐</span>
        <span class="tab-item" :class="{ active: activeTab === 'art' }" @click="activeTab = 'art'">美术</span>
      </div>
      <div _pos="relative" _w="full">
        <div _pos="absolute" _h="1px" _w="full" _bg="[#eeeeee]"></div>
        <div _pos="absolute" _h="2px" _w="43px" _bg="[#FF5E2A]" :style="{
          transition: 'all 0.3s',
          left: activeTab === 'music' ? '16px' : '84px'
        }"></div>
      </div>
      <div class="description">
        <span>说明：设置每一种题型学生的答题情况正确率(%),不同正确率对应不同赋分情况（分）</span>
      </div>
    </div>

    <!-- 卡片网格 -->
    <div class="cards-grid">
      <div v-for="(item) in dataList" :key="item.question_type" class="card">
        <!-- 卡片头部 -->
        <div class="card-header">
          <span class="card-title">{{ item.title }}</span>
          <div 
            class="edit-btn" 
            v-if="
              $store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value || 
              ($store.state.user.userInfo.type === $api.account.types.OTHER.value && $permissions('SA22003'))
            " 
            @click="handleEdit(item)"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.84375 7.84555L13.7284 1.96094" stroke="#4A4A4A" stroke-width="1.96154"
                stroke-linecap="round" />
              <path
                d="M9.80709 1.96094H4.57632C3.13188 1.96094 1.96094 3.13189 1.96094 4.57632V11.1148C1.96094 12.5592 3.13189 13.7302 4.57632 13.7302H11.1148C12.5592 13.7302 13.7302 12.5592 13.7302 11.1148V5.88401"
                stroke="#4A4A4A" stroke-width="1.96154" stroke-linecap="round" />
            </svg>
          </div>
        </div>

        <!-- 表现分行 -->
        <div class="score-rows">
          <div v-for="(scoreItem, sIndex) in item.scores" :key="sIndex" class="score-row">
            <span class="score-label">题型赋分：{{ scoreItem.score }}分</span>
            <span class="score-value">{{ scoreItem.percentage }}%</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 编辑弹窗 -->
    <el-dialog :visible.sync="editVisible" :title="`编辑过程分（${currentEditItem?.title || ''}）`" width="466px"
      :close-on-click-modal="false" custom-class="edit-dialog">
      <div class="edit-content">
        <!-- 表头 -->
        <div class="edit-header">
          <span class="edit-header-item">正确率（%）</span>
          <span class="edit-header-item">赋分（分）</span>
          <span class="edit-header-item">操作</span>
        </div>

        <!-- 表格行 -->
        <transition-group :key="editVisible" name="sort-animation" tag="div" class="edit-rows-container">
          <div v-for="(row, index) in editRows" :key="row._uid" class="edit-row">
            <div class="edit-input-wrapper">
              <el-input v-model="row.percentage" size="small" placeholder="请输入" class="edit-input"
                :class="{ 'is-error': row.percentageError }" @input="handlePercentageInput(index)"
                @blur="handlePercentageBlur(index)" />
            </div>
            <div class="edit-score-wrapper">
              <el-input v-model="row.score" size="small" placeholder="请输入" class="edit-score-input"
                :class="{ 'is-error': row.scoreError }" @input="handleScoreInput(index)" @blur="handleScoreBlur(index)" />
            </div>
            <div class="edit-delete" @click="handleDeleteRow(index)">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 5.57812L15 5.57812" stroke="#4B4B4B" stroke-linecap="round" />
                <path
                  d="M4.71094 7.28906V13.8605C4.71094 14.9651 5.60637 15.8605 6.71094 15.8605H11.2824C12.3869 15.8605 13.2824 14.9651 13.2824 13.8605V7.28906"
                  stroke="#4B4B4B" stroke-linecap="round" />
                <path
                  d="M12.4297 5.57812V4.0067C12.4297 3.45441 11.982 3.0067 11.4297 3.0067H6.57254C6.02026 3.0067 5.57254 3.45441 5.57254 4.0067V5.57812"
                  stroke="#4B4B4B" stroke-linecap="round" />
                <path d="M7.28906 7.28906V13.2891" stroke="#4B4B4B" stroke-linecap="round" />
                <path d="M10.7109 7.28906V13.2891" stroke="#4B4B4B" stroke-linecap="round" />
              </svg>
              <span _m="l-5px">删除</span>
            </div>
          </div>
        </transition-group>

        <!-- 添加按钮 -->
        <div class="add-row-btn" @click="handleAddRow">
          <i class="el-icon-plus"></i>
          <span>添加</span>
        </div>
      </div>


      <div slot="footer" class="edit-footer">
        <div _w="430px" _m="auto" _h="1px" _bg="[#f8f8f8]" _pos="absolute" _bottom="[90px]"></div>
        <el-button @click="editVisible = false" class="cancel-btn">取消</el-button>
        <el-button type="primary" @click="handleSaveEdit" class="confirm-btn">确定</el-button>
      </div>
    </el-dialog>
    
  </div>
</template>

<script>
import {
  // typeList,
  questionType,
} from './const.js'

export default {
  name: 'PerformanceValueManagement',
  data() {
    return {
      activeTab: 'music',
      editVisible: false,
      currentEditItem: null,
      editRows: [],
      dataList: []
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      try {
        const subject_id = this.activeTab === 'music' ? 1 : 2
        const res = await this.$api.user.httpGet('eval/question-score', {
          subject_id
        })
        // 兼容多种返回格式
        const data = Array.isArray(res) ? res : (res.data || [])
        console.log('API返回数据:', data)
        this.dataList = this.formatData(data)
      } catch (error) {
        console.error('获取数据失败:', error)
        // 使用默认数据
        this.dataList = this.getDefaultData()
      }
    },
    getDefaultData() {
      const subjectId = this.activeTab === 'music' ? 1 : 2
      const types = questionType[subjectId] || []
      return types.map((item) => ({
        dbId: null,
        question_type: item.value,
        title: item.label,
        icon: `#icon-type-${item.value}`,
        scores: []
      }))
    },
    formatData(data) {
      if (!data || data.length === 0) {
        return this.getDefaultData()
      }

      const subjectId = this.activeTab === 'music' ? 1 : 2
      const types = questionType[subjectId] || []

      // 按 question_type 建立映射
      const typeMap = {}
      data.forEach(item => {
        typeMap[item.question_type] = {
          dbId: item.id,
          scores: item.question_value || []
        }
      })

      // 根据 questionType 映射生成列表
      return types.map(typeItem => {
        const matchedData = typeMap[typeItem.value]
        return {
          dbId: matchedData?.dbId || null,
          question_type: typeItem.value,
          title: typeItem.label,
          icon: `#icon-type-${typeItem.value}`,
          scores: matchedData?.scores || []
        }
      })
    },
    handleEdit(item) {
      this.currentEditItem = item
      this.editRows = JSON.parse(JSON.stringify(item.scores)).map((row, index) => ({
        ...row,
        _uid: Date.now() + index,
        percentageError: false,
        scoreError: false
      }))
      this.editVisible = true
    },
    handleAddRow() {
      this.editRows.push({
        _uid: Date.now(),
        percentage: '',
        score: '',
        percentageError: false,
        scoreError: false
      })
    },
    handleDeleteRow(index) {
      this.editRows.splice(index, 1)
      this.checkDuplicatePercentage()
    },
    handlePercentageInput(index) {
      let value = this.editRows[index].percentage
      if (value === '' || value === null || value === undefined) {
        return
      }

      // 转为字符串处理
      value = String(value)

      // 只允许数字
      const cleaned = value.replace(/[^\d]/g, '')
      if (cleaned !== value) {
        value = cleaned
      }

      // 限制范围 0-100
      if (value !== '') {
        const num = parseInt(value, 10)
        if (!isNaN(num)) {
          if (num < 0) {
            value = '0'
          }
          if (num > 100) {
            value = '100'
          }
        }
      }

      this.$set(this.editRows, index, {
        ...this.editRows[index],
        percentage: value,
        percentageError: false
      })
    },
    handlePercentageBlur(index) {
      // 转为数字
      const value = this.editRows[index].percentage
      if (value !== '' && value !== null && value !== undefined) {
        const num = Number(value)
        this.$set(this.editRows, index, {
          ...this.editRows[index],
          percentage: Math.min(100, Math.max(0, num))
        })
      }
      this.checkDuplicatePercentage()
      this.sortByPercentage()
    },
    handleScoreInput(index) {
      let value = this.editRows[index].score
      if (value === '' || value === null || value === undefined) {
        return
      }

      // 转为字符串处理
      value = String(value)
			// 智能输入：处理前导0的情况
      // 如果是 "0" 开头且有多个0，或者"0"后面跟的不是小数点，则只保留一个0
      if (value.length > 1 && value[0] === '0' && value[1] !== '.') {
        // 去掉所有前导0，保留一个
        value = '0' + value.substring(1).replace(/^0+/, '')
      }
      // 处理负数的情况："-0" 开头且后面跟的不是小数点
      if (value.length > 2 && value[0] === '-' && value[1] === '0' && value[2] !== '.') {
        // 去掉多余的0，只保留一个0
        value = '-0' + value.substring(2).replace(/^0+/, '')
      }
      // 只允许数字、负号、小数点
      const cleaned = value.replace(/[^\d.-]/g, '')
      if (cleaned !== value) {
        value = cleaned
      }

      // 负号只能在开头
      if (value.indexOf('-') > 0) {
        value = value.replace(/-/g, '')
      }

      // 限制只有一个负号
      const negativeCount = (value.match(/-/g) || []).length
      if (negativeCount > 1) {
        value = '-' + value.replace(/-/g, '')
      }

      // 小数点前必须有数字
      if (value === '.') {
        value = '0.'
      }
      if (value === '-.') {
        value = '-0.'
      }

      // 限制只有一个小数点
      const dotCount = (value.match(/\./g) || []).length
      if (dotCount > 1) {
        const firstDotIndex = value.indexOf('.')
        value = value.substring(0, firstDotIndex + 1) + value.substring(firstDotIndex + 1).replace(/\./g, '')
      }

      // 限制小数点后最多2位
      const dotIndex = value.indexOf('.')
      if (dotIndex !== -1 && value.length > dotIndex + 2) {
        value = value.substring(0, dotIndex + 2)
      }

      // 输入时就限制范围
      if (value && value !== '-' && value !== '.' && value !== '-.') {
        const num = parseFloat(value)
        if (!isNaN(num)) {
          if (num < -99.9) {
            value = '-99.9'
          }
          if (num > 99.9) {
            value = '99.9'
          }
        }
      }

      this.$set(this.editRows, index, {
        ...this.editRows[index],
        score: value,
        scoreError: false
      })
    },
    handleScoreBlur(index) {
      let value = this.editRows[index].score

      // 检查是否为空
      if (value === '' || value === null || value === undefined) {
        this.$set(this.editRows, index, {
          ...this.editRows[index],
          scoreError: true,
          score: ''
        })
        return
      }

      // 转换为数字并限制范围
      const num = parseFloat(value)
      if (!isNaN(num)) {
        let finalValue = num
        if (num < -99.99) {
          finalValue = -99.99
        }
        if (num > 99.99) {
          finalValue = 99.99
        }
        this.$set(this.editRows, index, {
          ...this.editRows[index],
          score: finalValue,
          scoreError: false
        })
      }
    },
    checkDuplicatePercentage() {
      // 重置所有错误状态
      this.editRows.forEach(row => {
        row.percentageError = false
      })

      // 检查重复百分比
      const percentageMap = {}
      this.editRows.forEach((row, index) => {
        const p = row.percentage
        if (p !== '' && p !== null && p !== undefined) {
          if (percentageMap[p] !== undefined) {
            // 标记重复的行
            this.editRows[percentageMap[p]].percentageError = true
            this.editRows[index].percentageError = true
          } else {
            percentageMap[p] = index
          }
        }
      })
    },
    sortByPercentage() {
      // 按百分比升序排序，空值放最后
      this.editRows.sort((a, b) => {
        const pA = a.percentage
        const pB = b.percentage

        if (pA === '' || pA === null || pA === undefined) return 1
        if (pB === '' || pB === null || pB === undefined) return -1

        return pA - pB
      })
    },
    async handleSaveEdit() {
      // 检查每一行的百分比和分值
      let hasEmptyError = false
      this.editRows.forEach((row, index) => {
        // 检查百分比是否为空
        const percentageEmpty = row.percentage === '' || row.percentage === null || row.percentage === undefined
        // 检查分值是否为空
        const scoreEmpty = row.score === '' || row.score === null || row.score === undefined

        // 如果有任何一项有值，另一项为空，则标记错误
        if ((!percentageEmpty && scoreEmpty) || (percentageEmpty && !scoreEmpty)) {
          if (percentageEmpty) {
            this.$set(this.editRows, index, { ...row, percentageError: true })
          }
          if (scoreEmpty) {
            this.$set(this.editRows, index, { ...this.editRows[index], scoreError: true })
          }
          hasEmptyError = true
        }
      })

      // 检查是否有重复百分比或分值为空
      const hasError = this.editRows.some(row => row.percentageError || row.scoreError)
      if (hasError || hasEmptyError) {
        this.$message.warning('存在重复的百分比或数据不完整，请修正')
        return
      }

      // 过滤空行（百分比和分值都为空的行）
      const validRows = this.editRows.filter(row =>
        row.percentage !== '' && row.percentage !== null && row.percentage !== undefined &&
        row.score !== '' && row.score !== null && row.score !== undefined
      )

      if (validRows.length === 0) {
        this.$message.warning('请至少添加一条表现分数据')
        return
      }

      try {
        const subject_id = this.activeTab === 'music' ? 1 : 2
        const params = {
          question_type: this.currentEditItem.question_type,
          subject_id,
          question_value: validRows.map(row => ({
            percentage: row.percentage,
            score: row.score
          }))
        }

        if (this.currentEditItem.dbId) {
          // 编辑：PUT
          await this.$api.user.httpPut(`eval/question-score/${this.currentEditItem.dbId}`, params)
        } else {
          // 新建：POST
          await this.$api.user.httpPost('eval/question-score', params)
        }

        this.$message.success('保存成功')
        this.editVisible = false
        this.fetchData()
      } catch (error) {
        console.error('保存失败:', error)
        this.$message.error('保存失败')
      }
    }
  },
  watch: {
    activeTab() {
      this.fetchData()
    }
  }
}
</script>

<style lang="scss" scoped>
.performance-value-management {
  padding: 0;
  background: #f5f5fb;
  min-height: calc(100vh - 40px);
}

// 顶部区域
.header-section {
  width: 100%;
  height: 104px;
  background: white;
  border-radius: 8px;
  margin-bottom: 24px;
}

.tabs-wrapper {
  margin-bottom: 10px;
}

.tab-item {
  display: inline-block;
  font-size: 18px;

  font-weight: 400;
  color: #BBBBBB;
  cursor: pointer;
  padding: 0 16px;
  transition: color 0.3s;

  &:first-child {
    padding-left: 0;
  }

  &.active {
    color: #4A4A4A;
  }
}

.description {
  align-items: center;
  display: flex;
  align-items: flex-start;
  font-size: 16px;
  font-weight: 400;
  color: #B0B0B0;
  padding: 14px 16px;
}

.info-icon {
  font-size: 14px;
  margin-right: 6px;
  color: #B0B0B0;
}

// 卡片网格
.cards-grid {
  display: grid;
  grid-template-columns: repeat(4, 398px);
  gap: 24px;
  padding: 0;
}

// 卡片
.card {
  width: 398px;
  height: 226px;
  background: white;
  border-radius: 8px;
  box-sizing: border-box;
  overflow: hidden;
}

.card-header {
  display: flex;
  align-items: center;
  margin: 0 20px;
  margin-top: 26px;
  margin-bottom: 26px;
}

.card-icon {
  width: 32px;
  height: 32px;
  margin-right: 12px;
  font-size: 32px;
  color: #FF5E2A;
}

.card-title {
  flex: 1;
  font-size: 20px;
  font-weight: 400;
  color: #494949;
}

.edit-btn {
  width: 34px;
  height: 34px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #F5F5F5;
  border-radius: 4px;

  .icon {
    width: 16px;
    height: 16px;
    color: #3f6af7;
  }
}

// 表现分行
.score-rows {
  max-height: 130px;
  overflow: auto;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  padding: 0 10px;
  margin: 0 10px;
  padding-bottom: 10px;

  // 滚动条样式
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 3px;
    transition: background 0.3s;
  }

  &:hover,
  &:focus,
  &:focus-within {
    &::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.2);
    }
  }
}

.score-row {
  width: calc(50% - 6px);
  min-width: 0;
  height: 44px;
  background: #F9FBFF;
  border-radius: 4px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  box-sizing: border-box;
}

.score-label {
  flex: 1;
  font-size: 14px;

  font-weight: 400;
  color: #808080;
  white-space: nowrap;
}

.score-value {
  font-size: 14px;

  font-weight: 600;
  color: #272727;
  white-space: nowrap;
}

// 编辑弹窗
::v-deep .edit-dialog {
  border-radius: 6px;
  box-shadow: 4px 4px 30px rgba(133.87, 131.64, 131.64, 0.25);

  .el-dialog__header {
    padding: 20px 20px 15px;
    border-bottom: none;
  }

  .el-dialog__title {
    font-size: 18px;

    font-weight: 500;
    color: #323232;
  }

  .el-dialog__body {
    padding: 0 20px 20px;
  }
}

.edit-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.edit-rows-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.edit-header {
  display: flex;
  gap: 12px;
}

.edit-header-item {
  flex: 1;
  font-size: 16px;
  font-weight: 400;
  color: #323232;
  background-color: #F2F2F2;
  height: 36px;
  text-align: center;
  line-height: 36px;
  border-radius: 4px;
}

.edit-row {
  display: flex;
  gap: 12px;
  align-items: center;
}

// 排序动画
.sort-animation-move {
  transition: transform 0.3s ease;
}

.edit-input-wrapper {
  flex: 1;
}

.edit-score-wrapper {
  flex: 1;
}

.edit-input,
.edit-score-input {
  ::v-deep .el-input__inner {
    height: 36px;
    border-radius: 4px;
    border: 1px solid #DCDCDC;
    font-size: 14px;
    color: #0F0F0F;
    text-align: center;
  }

  &.is-error {
    ::v-deep .el-input__inner {
      border-color: #F56C6C;
      border-width: 1px;
    }
  }
}

.edit-delete {
  height: 36px;
  flex: 1;
  font-size: 14px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4B4B4B;
  cursor: pointer;
  background-color: #F7F8FA;

  &:hover {
    color: #FF5E2A;
  }
}

.add-row-btn {
  width: 60px;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  margin-top: 8px;

  i {
    font-size: 14px;
    color: #FF5E2A;
  }

  span {
    font-size: 14px;

    font-weight: 400;
    color: #FF5E2A;
  }
}

.edit-footer {
  display: flex;
  justify-content: center;
  gap: 20px;
  padding: 10px 0;
  padding-top: 25px;
}

.cancel-btn {
  width: 88px;
  height: 33px;
  background: #F6F6F6;
  border-radius: 2px;
  border: none;
  color: #4B4B4B;
  font-size: 14px;
}

.confirm-btn {
  width: 88px;
  height: 33px;
  background: #FF5E2A;
  border-radius: 4px;
  border: none;
  color: white;
  font-size: 14px;
}

// 响应式布局
@media (max-width: 2100px) {
  .cards-grid {
    grid-template-columns: repeat(4, minmax(300px, 1fr));

    .card {
      width: 100%;
    }
  }
}

@media (max-width: 1880px) {
  .cards-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 1440px) {
  .cards-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 1100px) {
  .cards-grid {
    grid-template-columns: 1fr;
  }
}
</style>
